<!-- Form container -->
<ion-list lines="full" class="ion-padding">
  <!-- Plan Name Input -->
  <ion-item>
    <ion-input
      placeholder="Plan Name"
      label="Plan Name"
      labelPlacement="floating"
      type="text"
      required
      [(ngModel)]="planName"
      autocapitalize="words"
    ></ion-input>
  </ion-item>

  <!-- Plan Description Input -->
  <ion-item>
    <ion-textarea
      placeholder="Plan Description"
      label="Plan Description"
      labelPlacement="floating"
      [(ngModel)]="planDescription"
      autocapitalize="sentences"
    ></ion-textarea>
  </ion-item>

  <!-- Default Set Count Selector -->
  <ion-item>
    <ion-select
      placeholder="Default Sets"
      label="Default Sets"
      labelPlacement="floating"
      placeholder="Select One"
      interface="popover"
      [(ngModel)]="defaultSets"
    >
      <ion-select-option
        *ngFor="let count of [].constructor(20); let i = index"
        [value]="i+1"
        >{{i+1}}</ion-select-option
      >
    </ion-select>
  </ion-item>

  <app-select-exercise
    (exerciseAdded)="addExercise($event)"
    (exercisesEmitted)="addExercises($event)"
  ></app-select-exercise>
</ion-list>

<ion-reorder-group (ionItemReorder)="doReorder($event)" disabled="false">
  <ion-item *ngFor="let exercisePlan of exercisesRefs; let i = index">
    <ng-container *ngIf="exercisePlan.id | getExercise | async as exercise">


    <ion-thumbnail slot="start" class="custom-thumbnail" *ngIf="{error: false} as dbImageError">
      <app-exercise-thumbnail [exercise]="exercise"></app-exercise-thumbnail>
    </ion-thumbnail>
    <ion-label>
      <h2>{{ exercise.sportName }}</h2>
      <ion-input
        placeholder="Sets"
        label="Sets"
        labelPlacement="floating"
        type="number"
        min="1"
        [(ngModel)]="exercisePlan.sets"
      ></ion-input>
    </ion-label>
    <div class="end-item" slot="end">
      <ion-reorder ></ion-reorder>
      <ion-button
        fill="outline"
        (click)="removeExercise(exercisePlan.id)"
        class="remove-button"
        color="danger"
        size="small"
        slot="end"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </div>
  </ng-container>
  </ion-item>
</ion-reorder-group>

<ion-button
  [disabled]="!planName || !exercisesRefs.length || loading"
  expand="block"
  class="py"
  (click)="emitPlan()"
>
  <ion-spinner *ngIf="loading" slot="start"></ion-spinner>
  Save Plan
</ion-button>
